/* NĒM AJAX cart: add, change quantity, remove, and re-render the drawer
   through the Section Rendering API. Replaces the WooCommerce side-cart plugin. */
(function () {
  'use strict';

  var config = window.oxyvape || {};
  var routes = config.routes || {};
  var SECTION_ID = 'cart-drawer';

  var drawer = document.getElementById('oxyCartDrawer');
  var overlay = document.querySelector('[data-cart-overlay]');

  var hideTimer = null;

  function openDrawer() {
    if (!drawer) return;
    window.clearTimeout(hideTimer);
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    // Read layout once so the browser commits the closed position before the
    // class change; otherwise un-hiding and opening land in one frame and the
    // slide-in never animates.
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('oxy-drawer-open');
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('oxy-drawer-open');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      drawer.hidden = true;
      if (overlay) overlay.hidden = true;
    }, 320);
  }

  function updateCartCount(count) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function refreshDrawer() {
    var url = routes.root + '?sections=' + SECTION_ID;
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var markup = sections[SECTION_ID];
        if (!markup || !drawer) return;
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var freshBody = parsed.querySelector('[data-cart-body]');
        var currentBody = drawer.querySelector('[data-cart-body]');
        if (freshBody && currentBody) currentBody.innerHTML = freshBody.innerHTML;
      });
  }

  function handleError(error) {
    /* eslint-disable no-console */
    console.error('[oxyvape cart]', error);
    window.alert(config.strings ? config.strings.cartError : 'Cart error');
  }

  function postCart(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function addToCart(form, button) {
    var formData = new FormData(form);
    var payload = { items: [{}] };
    formData.forEach(function (value, key) {
      if (key === 'id') payload.items[0].id = value;
      else if (key === 'quantity') payload.items[0].quantity = parseInt(value, 10) || 1;
      else if (key.indexOf('properties[') === 0) {
        payload.items[0].properties = payload.items[0].properties || {};
        payload.items[0].properties[key.slice(11, -1)] = value;
      } else if (key === 'selling_plan') payload.items[0].selling_plan = value;
      // v2 product page: an optional starter refill rides along with the device
      else if (key === 'addon_id' && value) payload.items.push({ id: value, quantity: 1 });
    });

    if (button) button.classList.add('is-loading');

    return postCart(routes.cartAdd, payload)
      .then(function () {
        return fetch(routes.root + 'cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawer();
      })
      .then(openDrawer)
      .catch(handleError)
      .finally(function () {
        if (button) button.classList.remove('is-loading');
      });
  }

  function changeLine(key, quantity) {
    return postCart(routes.cartChange, { id: key, quantity: quantity })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawer();
      })
      .catch(handleError);
  }

  /* Delegated listeners so re-rendered markup keeps working. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && drawer) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.key, 0);
      return;
    }

    var down = event.target.closest('[data-qty-down]');
    var up = event.target.closest('[data-qty-up]');
    if (down || up) {
      event.preventDefault();
      var wrapper = (down || up).closest('[data-qty]');
      var input = wrapper.querySelector('[data-qty-input]');
      var next = (parseInt(input.value, 10) || 0) + (up ? 1 : -1);
      if (next < 0) next = 0;
      input.value = next;
      changeLine(input.dataset.key, next);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input]');
    if (!input) return;
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    changeLine(input.dataset.key, quantity);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  window.oxyvapeCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
})();
